import { render, staticRenderFns } from "./selectPlaceholder.vue?vue&type=template&id=0b4a4712&"
import script from "./selectPlaceholder.vue?vue&type=script&lang=js&"
export * from "./selectPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports